var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { debounce } from 'lodash';
import { format, toDate, parseISO, isSameDay } from 'date-fns';
import UsageType from 'Stenbolaget-IntegrationService/Models/UsageType.cs';
import OrderRowType from 'Stenbolaget-IntegrationService/Models/OrderRowType.cs';
export const FORMAT_FULL_DATE = 'd MMM, yyyy';
export const FORMAT_DATE = 'yyyy-MM-dd';
const debounceFunctions = {};
const abortControllers = {};
export const CreateDebounce = (key, callback) => {
    var _a;
    (_a = debounceFunctions[key]) === null || _a === void 0 ? void 0 : _a.cancel();
    debounceFunctions[key] = debounce(callback, 500);
    debounceFunctions[key]();
    return debounceFunctions[key];
};
export const CreateRequest = (key, callback) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    (_a = abortControllers[key]) === null || _a === void 0 ? void 0 : _a.abort();
    abortControllers[key] = new AbortController();
    return yield callback(abortControllers[key]);
});
export const ToDate = (date) => date ? (typeof date === 'string' ? parseISO(date) : toDate(date)) : null;
export const FormatDate = (date, dateFormat = 'P') => {
    let currentDate = date;
    if (typeof date === 'string') {
        currentDate = new Date(date);
    }
    return date ? format(currentDate, dateFormat) : null;
};
export const IsDisplayUnit = (type) => {
    return (type & UsageType.CustomerOrder) === UsageType.CustomerOrder;
};
export const GetUnitConversion = (part) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const default_unit = (_b = (_a = part.partUnitUsages) === null || _a === void 0 ? void 0 : _a.find((unitUsage) => unitUsage.id === (part === null || part === void 0 ? void 0 : part.standardPartUnitUsageId))) !== null && _b !== void 0 ? _b : {
        id: '',
        unit: { code: 'PCE' },
        conversionFactor: 1,
    };
    const display_unit = (_d = (_c = part.partUnitUsages) === null || _c === void 0 ? void 0 : _c.find((f) => IsDisplayUnit(f.usageType))) !== null && _d !== void 0 ? _d : default_unit;
    const extra_unit = (_e = part.partUnitUsages) === null || _e === void 0 ? void 0 : _e.find((f) => !IsDisplayUnit(f.usageType) && f.id !== (default_unit === null || default_unit === void 0 ? void 0 : default_unit.id));
    return {
        default: {
            code: (_g = (_f = default_unit === null || default_unit === void 0 ? void 0 : default_unit.unit) === null || _f === void 0 ? void 0 : _f.code) !== null && _g !== void 0 ? _g : 'PCE',
            conversionFactor: Number((_h = default_unit === null || default_unit === void 0 ? void 0 : default_unit.conversionFactor) !== null && _h !== void 0 ? _h : 1),
        },
        display: {
            code: (_k = (_j = display_unit === null || display_unit === void 0 ? void 0 : display_unit.unit) === null || _j === void 0 ? void 0 : _j.code) !== null && _k !== void 0 ? _k : 'PCE',
            conversionFactor: Number((_l = display_unit === null || display_unit === void 0 ? void 0 : display_unit.conversionFactor) !== null && _l !== void 0 ? _l : 1),
        },
        extra: ((_m = extra_unit === null || extra_unit === void 0 ? void 0 : extra_unit.unit) === null || _m === void 0 ? void 0 : _m.code)
            ? {
                code: (_o = extra_unit.unit.code) !== null && _o !== void 0 ? _o : 'PCE',
                conversionFactor: Number((_p = extra_unit.conversionFactor) !== null && _p !== void 0 ? _p : 1),
            }
            : null,
    };
};
export const CustomerOrderRowQuantityUnitConversion = (customeOrderRow) => {
    if (!customeOrderRow.part) {
        return null;
    }
    const unitConversion = GetUnitConversion(customeOrderRow.part);
    const quantity = Math.abs(Number(customeOrderRow.orderedQuantity));
    return {
        default: Object.assign(Object.assign({}, unitConversion.default), { quantity: Math.ceil(quantity / unitConversion.default.conversionFactor) }),
        display: Object.assign(Object.assign({}, unitConversion.display), { quantity: Math.ceil(quantity / unitConversion.display.conversionFactor) }),
        extra: unitConversion.extra
            ? Object.assign(Object.assign({}, unitConversion.extra), { quantity: Math.ceil(quantity / unitConversion.extra.conversionFactor) }) : null,
    };
};
export const CustomerOrderRowQuantity = (customeOrderRow) => {
    var _a, _b;
    return (_b = (_a = CustomerOrderRowQuantityUnitConversion(customeOrderRow)) === null || _a === void 0 ? void 0 : _a.default.quantity) !== null && _b !== void 0 ? _b : Math.abs(Number(customeOrderRow.orderedQuantity)) / Number(customeOrderRow.conversionFactor);
};
export const CustomerOrderRowUnit = (customeOrderRow) => { var _a, _b, _c, _d; return (_d = (_b = (_a = CustomerOrderRowQuantityUnitConversion(customeOrderRow)) === null || _a === void 0 ? void 0 : _a.default.code) !== null && _b !== void 0 ? _b : (_c = customeOrderRow.unit) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : 'st'; };
export const CustomerOrderRowPrice = (customeOrderRow) => { var _a; return Number((_a = customeOrderRow.price) !== null && _a !== void 0 ? _a : 1) / (customeOrderRow.conversionFactor || 1); };
export const CustomerOrderRowTotalPrice = (customeOrderRow) => customeOrderRow.orderedQuantityInOrderUnit *
    (Number(customeOrderRow.price) - Number(customeOrderRow.price) * (Number(customeOrderRow.discount) / 100));
export const CustomerOrderTotalPrice = (customerOrder) => {
    var _a, _b, _c, _d;
    return ((_d = (_c = ((_b = (_a = customerOrder === null || customerOrder === void 0 ? void 0 : customerOrder.rows) === null || _a === void 0 ? void 0 : _a.filter((f) => f.orderRowType !== OrderRowType.Sum)) !== null && _b !== void 0 ? _b : [])) === null || _c === void 0 ? void 0 : _c.reduce((currentTotal, row) => currentTotal + CustomerOrderRowTotalPrice(row), 0)) !== null && _d !== void 0 ? _d : 0);
};
export const AddVAT = (amount) => amount * 1.25;
export const GetVAT = (amount) => amount * 1.25 - amount;
export const FormatDateRange = (dateFrom, dateTo) => {
    if (!dateFrom || !dateTo)
        return '';
    dateFrom = ToDate(dateFrom);
    dateTo = ToDate(dateTo);
    const sameDate = isSameDay(dateFrom, dateTo);
    if (sameDate) {
        return format(dateFrom, FORMAT_FULL_DATE);
    }
    return `${format(dateFrom, FORMAT_FULL_DATE)} - ${format(dateTo, FORMAT_FULL_DATE)}`;
};
